/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A_Coklu_KullaniciInputs */

const tr_faq_a_coklu_kullanici = /** @type {(inputs: Faq_A_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet. Ayarlar altındaki Kullanıcılar sayfasından ekip üyelerini davet edebilirsin. Her kullanıcıya farklı yetki seviyesi tanımlayabilirsin: Firma Sahibi, Yönetici, Depo veya İzleyici. Depo rolündeki kullanıcılar sadece kargo ve stok işlemlerini görebilir, mali bilgilere erişemez.`)
};

const en_faq_a_coklu_kullanici = /** @type {(inputs: Faq_A_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Invite team members from the Users page under Settings. Each user gets a role: Owner, Manager, Warehouse or Viewer. Warehouse users only see delivery and stock operations and cannot access financial data.`)
};

const de_faq_a_coklu_kullanici = /** @type {(inputs: Faq_A_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Lade Teammitglieder über die Seite Benutzer unter Einstellungen ein. Jeder Benutzer erhält eine Rolle: Eigentümer, Manager, Lager oder Betrachter. Lagerbenutzer sehen nur Versand- und Bestandsvorgänge, haben aber keinen Zugriff auf Finanzdaten.`)
};

const ru_faq_a_coklu_kullanici = /** @type {(inputs: Faq_A_Coklu_KullaniciInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да. Приглашайте участников на странице Пользователи в Настройках. Каждому назначается роль: Владелец, Менеджер, Склад или Наблюдатель. Пользователи со складской ролью видят только операции доставки и остатков, без доступа к финансовым данным.`)
};

/**
* | output |
* | --- |
* | "Yes. Invite team members from the Users page under Settings. Each user gets a role: Owner, Manager, Warehouse or Viewer. Warehouse users only see delivery an..." |
*
* @param {Faq_A_Coklu_KullaniciInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_a_coklu_kullanici = /** @type {((inputs?: Faq_A_Coklu_KullaniciInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A_Coklu_KullaniciInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_a_coklu_kullanici(inputs)
	if (locale === "de") return de_faq_a_coklu_kullanici(inputs)
	if (locale === "ru") return ru_faq_a_coklu_kullanici(inputs)
	return tr_faq_a_coklu_kullanici(inputs)
});